<template>
    <div class="content_box">
        <div class="top">
            <div class="title">
                <span>用户反馈</span>&nbsp;&nbsp;
            </div>
            <el-select v-model="region" placeholder="请选择" class="region-select" @change='regionChanged'
                style="width: 150px;">
                <el-option label="美洲数据中心" value="us"></el-option>
                <el-option label="中国数据中心" value="cn"></el-option>
                <el-option label="欧洲数据中心" value="eu"></el-option>
                <el-option label="亚太数据中心" value="ap"></el-option>
            </el-select>
        </div>
        <div class="area">
            <div class="content">
                <div class="search_box">
                    <el-form :inline="true" class="form-inline search-form form-list" label-width="110px">

                        <el-form-item class="searchSelect form_item" prop="searchInput">
                            <div slot="label">
                                <el-select v-model="search_key">
                                    <el-option label="问题标题" value="question_title"></el-option>
                                    <el-option label="问题ID" value="question_id"></el-option>
                                    <el-option label="用户ID" value="user_id"></el-option>
                                </el-select>
                            </div>
                            <el-input v-model="search_val" placeholder="请输入"></el-input>
                        </el-form-item>

                        <!-- <el-form-item>
                            <el-input placeholder="关键字" v-model="searchData.keys"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input placeholder="用户ID" @input="value => searchData.user_id = value.replace(/[^\d]/g, '')"
                                v-model="searchData.user_id"></el-input>
                        </el-form-item> -->

                        <el-form-item>
                            <div class="belong_box">
                                <el-select class="belong" v-model="searchData.is_belong" width="100">
                                    <el-option label="属于" :value="1"></el-option>
                                    <el-option label="不属于" :value="0" belong_selected></el-option>
                                </el-select>
                                <el-select v-model="searchData.area" filterable clearable placeholder="国家/地区">
                                    <el-option v-for="item in countryList" :key="item.id + '142'" :label="item.chinese"
                                        :value="item.abbr"></el-option>
                                </el-select>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="searchData.status" clearable placeholder="状态">
                                <el-option label="未读" value="0"></el-option>
                                <el-option label="已读" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="searchData.question_type" clearable placeholder="问题类型">
                                <el-option label="问题反馈" value="1"></el-option>
                                <el-option label="产品建议" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="searchData.is_solved" clearable placeholder="是否解决">
                                <el-option label="未填写" value="0"></el-option>
                                <el-option label="已解决" value="1"></el-option>
                                <el-option label="未解决" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="searchData.deal_name" filterable placeholder="处理人" clearable>
                                <el-option v-for="item in userList" :key="item.user_id" :label="item.user_name"
                                    :value="item.user_name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="form_item date_picker" label="创建时间">
                            <DatePicker :date="createTime" :clearable="true" @dateSelect="dateSelect"></DatePicker>
                        </el-form-item>
                        <el-form-item>
                            <div class="button search" @click="search">
                                <span>查询</span>
                            </div>
                            <div class="button search white" @click="init">
                                <span>重置</span>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
                <el-table :data="feedback_list" :fit="true" style="width:100%" highlight-current-row
                    @row-click="goDetail">
                    <el-table-column prop="id" label="问题ID" width="100"></el-table-column>
                    <el-table-column prop="user_id" label="用户ID" width="100"></el-table-column>
                    <el-table-column prop="product" label="产品型号">
                        <template slot-scope="scope">
                            <span>{{ scope.row.product || '--' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="question_type" label="问题类型">
                        <template slot-scope="scope">
                            <span v-if="scope.row.question_type == 1">问题反馈</span>
                            <span v-if="scope.row.question_type == 2">产品建议</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="title" label="标题" width="160" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="area" label="国家/地区" width="160" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="status" label="状态">
                        <template slot-scope="scope">
                            <span class="status3" v-if="scope.row.status == 0">未读</span>
                            <span class="status2" v-if="scope.row.status == 1">已读</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="is_solved" label="是否解决">
                        <template slot-scope="scope">
                            <span class="status1" v-if="scope.row.is_solved == 0">未填写</span>
                            <span class="status2" v-if="scope.row.is_solved == 1">已解决</span>
                            <span class="status3" v-if="scope.row.is_solved == 2">未解决</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deal_name" label="处理人">
                        <template slot-scope="scope">
                            <span>{{ scope.row.deal_name || '--' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="create_time" label="创建时间" width="160" sortable>
                        <template slot-scope="scope">
                            <span>{{ formDate(scope.row.create_time) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="update_time" label="更新时间" width="160">
                        <template slot-scope="scope">
                            <span>{{ formDate(scope.row.update_time) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="act" label="操作" width="160">
                        <template slot-scope="scope">
                            <div class="btn">
                                <div class="button text" @click.stop="toOrderDetail(scope.row)"
                                    v-if="scope.row.work_id != 0 && roleCheck('101-102-101-101')">
                                    <span>查看工单</span>
                                </div>
                                <div class="button text" @click.stop="toCreateOrder(scope.row.id)"
                                    v-else-if="scope.row.work_id == 0 && roleCheck('103-101-101-103') && roleCheck('101-102-101-103')">
                                    <span>转工单</span>
                                </div>
                                <div class="button text" @click.stop="del(scope.row.id)"
                                    v-if="roleCheck('103-101-101-104')">
                                    <span>删除</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>
                <Tip ref="delTip" msg="确定要删除问题吗，删除后不能再恢复哦！" @tipBack="tipBack"></Tip>
            </div>
        </div>
    </div>
</template>

<script>

export default ({
    name: 'user-feedback',
    data() {
        return {
            role: '',
            searchData: [],
            feedback_list: [],
            total: 0,
            listData: [],
            userList: [],
            region: 'us',
            createTime: [],
            countryList: [],
            delId: '',
            search_key: 'question_title',
            search_val: '',
        }
    },
    watch: {
        createTime: function (nTime) {
            if (nTime.length > 1) {
                this.searchData.begin_time = nTime[0];
                this.searchData.end_time = nTime[1];
            } else {
                this.searchData.begin_time = 0
                this.searchData.end_time = 0;
            }
        },
    },
    created() {
        if (!this.$route.query.region) {
            this.$router.replace('?region=us');
        }
        this.init();
        this.getUserList();
        this.getCountry();
        this.getFbList();
    },
    activated() {
        // this.getFbList();
    },
    methods: {
        search() {
            this.searchData.page = 1;
            this.getFbList();
        },
        dateSelect(date) {
            this.createTime = date ? [...date] : '';
        },
        getFbList() {
            this.searchData.user_id = '';
            this.searchData.question_id = '';
            this.searchData.question_title = '';
            if (this.search_key == 'question_id') {
                this.searchData.question_id = this.search_val;
            } else if (this.search_key == 'question_title') {
                this.searchData.question_title = this.search_val;
            } else {
                this.searchData.user_id = this.search_val;
            }
            this.api.getFbList(this.searchData).then(data => {
                var list = data.data.feedback_list;
                this.total = data.data.total;
                var that = this;
                list.forEach(function (item, index, arr) {
                    // console.log('+' + item.area);
                    that.countryList.forEach(country => {
                        if (country.abbr == item.area || country.code == item.area) {
                            arr[index].area = country.chinese;
                            return;
                        }
                    });
                });
                this.feedback_list = list;
            })
        },
        init() {
            this.searchData = {
                keys: '',
                user_id: '',
                question_id: '',
                question_title: '',
                page_size: 10,
                page: 1,
                is_belong: 1,
                deal_name: '',
                area: '',
                status: '',
                question_type: '',
                is_solved: '',
                end_time: '',
                begin_time: '',
            };
            this.createTime = [];
            this.region = this.$route.query.region || this.region;
            this.search_key = 'question_title';
            this.search_val = '';
        },
        getUserList() {
            this.api.getUser({}).then(data => {
                this.userList = data.data.userList
            })
        },
        regionChanged(val) {
            this.region = val;
            this.$router.replace('?region=' + val);
            // localStorage.setItem('Region', this.region);
            this.getFbList();
        },
        goDetail(row, column, event) {
            if (window.h5sdk) {
                this.$router.push({ name: 'feedback-detail', params: { id: row.id }, query: { title: row.title, region: this.region } });
                return;
            }
            const detail = this.$router.resolve({
                name: 'feedback-detail',
                params: {
                    id: row.id

                },
                query: { title: row.title, region: this.region }
            });
            window.open(detail.href, "_blank");
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getFbList();
        },
        toCreateOrder(id) {
            console.log(id)
            this.$router.push({ name: 'create-order', query: { feedback_id: id, region: this.region } });
        },
        toOrderDetail(row, column, event) {
            if (window.h5sdk) {
                this.$router.push({ name: 'order-detail', params: { id: row.work_id }, query: { title: row.title } });
                return;
            }
            const detail = this.$router.resolve({
                name: `order-detail`,
                params: {
                    id: row.work_id
                },
                query: {
                    title: row.title
                }
            });
            window.open(detail.href, "_blank");
        },
        getCountry() {
            this.api.getCountry({}).then(data => {
                this.countryList = data.data.country;
                // console.log(this.countryList);
            })
        },
        del(id) {
            this.$refs.delTip.show = true;
            this.delId = id;
        },
        tipBack() {
            this.api.delFeedback({ feedback_id: this.delId }).then(data => {
                this.$message.success('删除成功!');
                this.getFbList();
                this.$refs.delTip.show = false;
            });
        },
    }
})
</script>
<style lang="less" scoped>
.content_box {
    padding: 0;
}

.background {
    background-color: @colorWhite;
}

/deep/ .top {
    .flexLayout(space-between);
    padding: 20px;
    background-color: @colorWhite;
    .background();

    .el-input__inner {
        height: 32px;
        line-height: 32px;
    }

    .el-input__icon {
        line-height: 32px;
    }

    @media (max-width: 768px) {
        .el-input__inner {
            height: 28px;
            line-height: 28px;
        }

        .el-input__icon {
            line-height: 28px;
        }
    }
}

/deep/ td {
    cursor: pointer;
}

.area {
    padding: 20px;
    height: calc(100% - 80px);
    box-sizing: border-box;

    .status1 {
        color: #F8AF0C;
    }

    .status2 {
        color: #00D6B9;
    }

    .status3 {
        color: #EB534B;
    }

    .status4 {
        color: #2A79FF;
    }

    .datepicker {
        width: 200px;
    }

    @media (max-width: 768px) {
        /deep/.el-input__inner {
            width: 200px;
        }
    }
}

.belong_box {
    .flexLayout(flex-satrt);
    flex-wrap: nowrap;

    .belong {
        // padding-right: 10px;

        /deep/ .el-input__inner {
            width: 100px !important;
            min-width: 90px !important;
        }

    }
}

.region-select {
    width: 200px;
}
</style>


// WEBPACK FOOTER //
// src/view/app/user-feedback/user-feedback.vue